import { StanjeRobeCustomer } from '../types';

export function getCustomerBrandIds(customer?: StanjeRobeCustomer | null): string[] {
  if (!customer) return [];
  if (Array.isArray(customer.brandIds) && customer.brandIds.length) {
    return customer.brandIds.map((id) => (typeof id === 'string' ? id : id?._id || '')).filter(Boolean);
  }
  if (customer.brandId) {
    return [typeof customer.brandId === 'string' ? customer.brandId : customer.brandId?._id || ''].filter(Boolean);
  }
  return [];
}

export function getCustomerBrandNames(customer?: StanjeRobeCustomer | null): string[] {
  if (!customer) return [];
  if (Array.isArray(customer.brandNames) && customer.brandNames.length) {
    return customer.brandNames.filter(Boolean);
  }
  if (customer.brandName) return [customer.brandName];
  return [];
}

export function formatCustomerBrands(customer?: StanjeRobeCustomer | null): string {
  return getCustomerBrandNames(customer).join(', ');
}

export function customerHasBrand(customer: StanjeRobeCustomer | null | undefined, brandId?: string | null): boolean {
  if (!customer || !brandId) return false;
  return getCustomerBrandIds(customer).includes(String(brandId));
}
